<template>
    <div class="bg-white rounded-2xl border border-gray-200 p-4 space-y-4">
        <div>
            <p class="text-lg font-bold text-slate-900">Appareil</p>
            <p class="text-sm text-slate-500 mt-0.5">Des informations supplémentaires sont requises pour cet appareil.</p>
        </div>

        <div class="relative">
            <input
                v-model="marque"
                type="text"
                :class="[
                    'w-full rounded-xl px-4 py-3.5 text-base font-mono tracking-widest uppercase outline-none',
                    marque ? 'border border-gray-200 focus:border-blue-500' : 'border-2 border-red-500 focus:border-red-600'
                ]"
                placeholder="Marque de l'appareil"
                autocomplete="off"
                @input="marque = marque.charAt(0).toUpperCase() + marque.slice(1).toLowerCase()"
            />
            <i v-if="!marque" class="fas fa-exclamation-triangle absolute right-4 top-1/2 -translate-y-1/2 text-red-500"></i>
        </div>

        <div class="relative">
            <input
                v-model="model"
                type="text"
                :class="[
                    'w-full rounded-xl px-4 py-3.5 text-base font-mono tracking-widest uppercase outline-none',
                    model ? 'border border-gray-200 focus:border-blue-500' : 'border-2 border-red-500 focus:border-red-600'
                ]"
                placeholder="Modèle de l'appareil"
                autocomplete="off"
                @input="model = model.charAt(0).toUpperCase() + model.slice(1).toLowerCase()"
            />
            <i v-if="!model" class="fas fa-exclamation-triangle absolute right-4 top-1/2 -translate-y-1/2 text-red-500"></i>
        </div>

        <div class="relative">
            <input
                v-model="serialNumber"
                type="text"
                :class="[
                    'w-full rounded-xl px-4 py-3.5 text-base font-mono tracking-widest uppercase outline-none',
                    serialNumber ? 'border border-gray-200 focus:border-blue-500' : 'border-2 border-red-500 focus:border-red-600'
                ]"
                placeholder="Numéro de série"
                autocomplete="off"
                @input="serialNumber = serialNumber.toUpperCase()"
            />
            <i v-if="!serialNumber" class="fas fa-exclamation-triangle absolute right-4 top-1/2 -translate-y-1/2 text-red-500"></i>
        </div>

        <button
            class="w-full flex items-center justify-center gap-2 py-3 border border-dashed border-gray-300 hover:border-gray-400 rounded-xl text-slate-500 text-sm font-medium transition-colors"
            @click="setIntrouvable"
        >
            <svg class="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 015.83 1c0 2-3 3-3 3M12 17h.01"/></svg>
            Numéro de série introuvable ou illisible
        </button>
    </div>
</template>

<script>
export default {
    name: 'StepSerialNumber',
    inject: ['wm'],

    computed: {
        serialNumber: {
            get() { return this.wm.editedAppareil?.numero_serie ?? ''; },
            set(val) { this.updateAppareil({ numero_serie: val }); },
        },
        marque: {
            get() { return this.wm.editedAppareil?.marque ?? ''; },
            set(val) { this.updateAppareil({ marque: val }); },
        },
        model: {
            get() { return this.wm.editedAppareil?.model ?? ''; },
            set(val) { this.updateAppareil({ model: val }); },
        },
    },

    methods: {
        updateAppareil(patch) {
            // 1. Merge dans editedAppareil
            this.wm.editedAppareil = { ...this.wm.editedAppareil, ...patch };

            // 2. Merge dans formData.appareil en préservant les autres champs
            this.wm.updateFormData({
                appareil: {
                    ...this.wm.formData.appareil,
                    id: this.wm.intervention.appareil.id,
                    ...patch,
                },
            });
        },

        setIntrouvable() {
            this.updateAppareil({ numero_serie: 'Introuvable' });
            this.$emit('next');
        },
    },
};
</script>